import React, { useEffect, useState } from "react";
import {
    getBulkDropdownData,
    getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import LoadingSpinner from "../../LoadingSpinner";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { statusByContext } from "../../../api/statusApi";
import { STATUS_GROUPS } from "../../../const";

const PerformanceFinanceSearch = ({
                                      searchResHandler,
                                      resetHandler,
                                      dateType,
                                      setDateType
                                  }) => {
    const userData = useSelector((state) => state.user.userDetails);
    const user = useSelector((state) => state.user);

    const [dateTypeData, setDateTypeData] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [resetSearchFields, setResetSearchFields] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [reloadDates, setReloadDates] = useState(true);

    const [vehicle, setVehicle] = useState("");
    const [vehicleValue, setVehicleValue] = useState("");
    const [jobStatusOptions, setJobStatusOptions] = useState([]);

    const [customer, setCustomer] = useState([]);
    const [shipper, setShipper] = useState([]);
    const [reqNos, setReqNos] = useState("");
    const [referenceNos, setReferenceNos] = useState("");
    const [vehNos, setVehNos] = useState("");
    const [jobStatus, setJobStatus] = useState([]);
    const [startLocations, setStartLocations] = useState([]);
    const [endLocations, setEndLocations] = useState([]);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const {
                date_types: dateTypeData = [],
            } = await getBulkDropdownData([
                { key: "date_types" },
            ]);
            setDateTypeData(dateTypeData);

            const jobStatusData = await statusByContext(
                userData.type === 2
                    ? STATUS_GROUPS.CUSTOMER_STATUS
                    : userData.type === 3
                        ? STATUS_GROUPS.TRANSPORTER_STATUS
                        : STATUS_GROUPS.ALL,
            );
            setJobStatusOptions(jobStatusData);

            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        if (reloadDates) {
            const aWeekAgo = new Date();
            aWeekAgo.setDate(aWeekAgo.getDate() - 7);
            const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
            const formattedToday = new Date().toISOString().split("T")[0];
            setFromDate(formattedWeekAgo);
            setToDate(formattedToday);
        }
        setReloadDates(false);
    }, [reloadDates]);

    const getValueOrDefault = (value, defaultValue = "-2") => {
        if (Array.isArray(value)) {
            return value.length > 0 ? value.join(",") : defaultValue;
        }
        return value && value.toString().trim() !== ""
            ? value.toString()
            : defaultValue;
    };

    const onSearch = (e) => {
        e.preventDefault();
        if (!fromDate || !toDate) {
            toast.warn("From date and To date are mandatory", {
                autoClose: 5000,
                containerId: "Main",
            });
            return;
        }

        searchResHandler({
            dateType,
            fromDate: getValueOrDefault(fromDate),
            toDate: getValueOrDefault(toDate),
            customer: getValueOrDefault(customer),
            shipper: getValueOrDefault(shipper),
            jobStatus: getValueOrDefault(jobStatus),
            vehicle: getValueOrDefault(vehNos),
            reference: getValueOrDefault(referenceNos),
            request: getValueOrDefault(reqNos),
            pickup: getValueOrDefault(startLocations),
            delivery: getValueOrDefault(endLocations),
        });
    };

    const onReset = (e) => {
        e.preventDefault();
        setResetSearchFields(true);
        setDateType(1);
        setVehicle("");
        setVehicleValue("");
        setCustomer([]);
        setShipper([]);
        setReqNos("");
        setReferenceNos("");
        setVehNos("");
        setJobStatus([]);
        setStartLocations([]);
        setEndLocations([]);
        setReloadDates(true);
        resetHandler();
        setTimeout(() => setResetSearchFields(false), 0);
    };

    return isLoading ? (
        <LoadingSpinner />
    ) : (
        <form className="ui form">
            <h4 className="ui dividing header">Information</h4>

            <div className="four fields">
                <div className="field">
                    <Dropdown
                        required
                        options={dateTypeData}
                        label="Date Filter"
                        placeholder="Date Type"
                        value={dateType}
                        onChange={(e, data) => setDateType(data.value)}
                        clearable={false}
                    />
                </div>
                <Input
                    required
                    type="date"
                    label="From Date"
                    name="fromDate"
                    max={toDate ?? new Date().toISOString().split("T")[0]}
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                />
                <Input
                    required
                    label="To Date"
                    type="date"
                    name="toDate"
                    min={fromDate}
                    value={toDate}
                    disabled={!fromDate}
                    onChange={(e) => setToDate(e.target.value)}
                />
                <Dropdown
                    clearable
                    search
                    options={jobStatusOptions}
                    placeholder="Job Status"
                    label="Job Status"
                    value={jobStatus}
                    onChange={(e, data) => setJobStatus(data.value)}
                    multiple
                />
            </div>

            <div className="four fields">
                <SearchDropdown
                    key="customer"
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple
                    label="Customer"
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                        type: "stakeholder_type",
                        value: "Customer",
                    }}
                    onResultSelect={(data) => setCustomer((prev) => [...prev, data])}
                    multiValueRemoveHandler={(key) =>
                        setCustomer((prev) => prev.filter((item) => item !== parseInt(key)))
                    }
                />
                <SearchDropdown
                    key="shipper"
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple
                    label="Shipper/Plant"
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                        type: "stakeholder_type",
                        value: "Shipper",
                        param2: customer.length > 0 ? customer.join(",") : "",
                    }}
                    onResultSelect={(data) =>
                        setShipper((prev) => {
                            const id = parseInt(data);
                            return prev.includes(id) ? prev : [...prev, id];
                        })
                    }
                    multiValueRemoveHandler={(key) =>
                        setShipper((prev) =>
                            prev.filter((item) => item !== parseInt(key))
                        )
                    }

                />
                <Input
                    label="Request Id"
                    placeholder="Ex:REQ00000123"
                    name="reqnos"
                    value={reqNos}
                    onChange={(e) => setReqNos(e.target.value)}
                />
                <Input
                    label="Reference No"
                    // placeholder="Ex:REF-00000123"
                    name="refnos"
                    value={referenceNos}
                    onChange={(e) => setReferenceNos(e.target.value)}
                />
            </div>

            <div className="three fields">
                <Input
                    label="Vehicle No"
                    placeholder="Ex:LG-0123"
                    name="vehnos"
                    value={vehNos}
                    onChange={(e) => setVehNos(e.target.value)}
                />
                <SearchDropdown
                    key="start-location"
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple
                    label="Pickup Location"
                    api={getOtherRefSearchDropdown}
                    apiDependency={{ type: "location", value: "" }}
                    onResultSelect={(data) => setStartLocations((prev) => [...prev, data])}
                    multiValueRemoveHandler={(key) =>
                        setStartLocations((prev) => prev.filter((item) => item !== parseInt(key)))
                    }
                />
                <SearchDropdown
                    key="end-location"
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple
                    label="Delivery Location"
                    api={getOtherRefSearchDropdown}
                    apiDependency={{ type: "location", value: "" }}
                    onResultSelect={(data) => setEndLocations((prev) => [...prev, data])}
                    multiValueRemoveHandler={(key) =>
                        setEndLocations((prev) => prev.filter((item) => item !== parseInt(key)))
                    }
                />
            </div>

            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <div className="field" style={{ width: "100%" }}>
                    <Button template="search" onClick={onSearch} />
                    <Button template="searchReset" onClick={onReset} />
                </div>
            </div>
        </form>
    );
};

export default PerformanceFinanceSearch;
